import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';

import {
    APIProductPackageRalDelete,
    APIProductPackageRalDeleteParams,
    APIProductPackageRalPost,
    APIProductPackageRalPostParams,
    APIProductPackageRalsGetList,
    ProductPackageRal,
} from './ProductPackageRals.api';

export type FormattedProductPackageRal = ProductPackageRal & {
    id: string;
    resourceDisplayName: string;
};

const formatRals = (rows: ProductPackageRal[]): FormattedProductPackageRal[] =>
    rows.map(item => ({
        ...item,
        id: `${item.aclResourceId}.${item.accessId}`,
        resourceDisplayName: item.aclDisplayName || item.aclName,
    }));

export const fetchProductPackageRals = createAsyncThunk(
    'productPackageRals/fetchProductPackageRals',
    async (item: { tenantId: string; productPackageId: string; signal?: AbortSignal }) => {
        const response = await APIProductPackageRalsGetList(item);
        return formatRals(response.data);
    }
);

export type PostProductPackageRalThunkResponse = {
    rows: FormattedProductPackageRal[];
};

export const postProductPackageRal = createAsyncThunk(
    'productPackageRals/postProductPackageRal',
    async (item: APIProductPackageRalPostParams) => {
        await APIProductPackageRalPost(item);
        const rows = formatRals(await handleListFetch(APIProductPackageRalsGetList({ tenantId: item.tenantId, productPackageId: item.productPackageId })));
        return { rows };
    }
);

export type DeleteProductPackageRalThunkResponse = {
    rows: FormattedProductPackageRal[];
};

export const deleteProductPackageRal = createAsyncThunk(
    'productPackageRals/deleteProductPackageRal',
    async (item: APIProductPackageRalDeleteParams) => {
        await APIProductPackageRalDelete(item);
        const rows = formatRals(await handleListFetch(APIProductPackageRalsGetList({ tenantId: item.tenantId, productPackageId: item.productPackageId })));
        return { rows };
    }
);
